import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";

const AppLayout = ({
  TopNavigation,
  SideNavigation,
  SideAction,
  PageContent,
}: {
  TopNavigation: any;
  SideNavigation: any;
  SideAction: any;
  PageContent: any;
}) => {
  return (
    <Layout
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: "white",
      }}
    >
      {/* Top Navigation - fixed height, never scrolls */}
      <div style={{ flexShrink: 0 }}>{TopNavigation}</div>

      {/* Main area - fills remaining space */}
      <Layout
        style={{
          flex: 1,
          minHeight: 0, // Critical: allows flex child to shrink below content size
          display: "flex",
          flexDirection: "row",
          overflow: "hidden",
          backgroundColor: "#f5f5f5",
        }}
        hasSider={true}
      >
        {SideNavigation}
        <Content
          style={{
            flex: 1,
            minHeight: 0, // Critical: allows flex child to shrink
            overflow: "auto",
          }}
        >
          {PageContent}
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
